<sirius-modal2
    [fullscreen]="true"
    [(open)]="modalOpen"
    [titleId]="titleId"
    [variant]="variant()"
    (modalOpen)="onModalOpen()"
    (modalClose)="onClose()"
>
    <h2 [id]="titleId" class="sir-visually-hidden">{{ currentTitle() }}</h2>
    <sirius-slider
        [startIndex]="startIndex()"
        [loop]="true"
        layout="fluid"
        [showArrows]="true"
        [showDots]="true"
        (selectedIndex)="setIndex($event)"
        (scrollNextEvent)="onScrollNext()"
        (scrollPreviousEvent)="onScrollPrevious()"
    >
        @for (item of items(); track $index) {
            <div class="sir-media-container">
                <div class="sir-media">
                    @switch (item.type) {
                        @case ('image') {
                            <sirius-image-item
                                [image]="item | cast"
                                objectFit="scale-down"
                                [fluid]="true"
                                (loaded)="onLoaded()"
                            >
                            </sirius-image-item>
                        }
                        @case ('video') {
                            <sirius-video-item
                                [video]="item | cast"
                                [canPlay]="index() === $index"
                                objectFit="contain"
                                [fluid]="true"
                                (click)="onVideoClick($event, $index)"
                                (loaded)="onLoaded()"
                            >
                            </sirius-video-item>
                        }
                    }
                </div>
                @if (showDescription() && item.title) {
                    <span class="sir-description sir-text-style-paragraph-m-default">{{ item.title }}</span>
                }
            </div>
        }
    </sirius-slider>
</sirius-modal2>
